import { render, staticRenderFns } from "./property-prices.vue?vue&type=template&id=83439658&"
import script from "./property-prices.vue?vue&type=script&lang=js&"
export * from "./property-prices.vue?vue&type=script&lang=js&"
import style0 from "./property-prices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports